import { appointment } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useApproveHomework = (appointmentId, onSuccess = () => {}) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: appointment.approveHomework,
    onSuccess: () => {
      queryClient.invalidateQueries(['appointment', appointmentId])
			onSuccess()
    },
  })

	return mutation
}